module.exports = __webpack_public_path__ + "img/message-question.92c01586.svg";